// extracted by mini-css-extract-plugin
export default {"container":"styles_container__O7gDI","title":"styles_title__7VTGJ","filter":"styles_filter__K1cOE","table":"styles_table__7RscE","tabs":"styles_tabs__Ugic8"};